import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { useNavigate } from "react-router-dom";

import { IUser } from "./interfaces";
import { Button } from "@mui/material";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { usersColumns } from "./components/usersColumns";
import { usersSearchFields } from "./components/usersSearchFields";

export const UserList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IUser>({
            initialCurrent: 1,
            initialPageSize: 20,
        });

    const [selectedRows, setSelectedRows] = React.useState<string[]>([]);
    const navigate = useNavigate();

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List
            breadcrumb={<></>}
            headerButtons={({ defaultButtons }) => (
                <>
                {defaultButtons}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        navigate("/alarms/create", { state: { ids: selectedRows }});
                    }}
                >
                    푸시알림 전송
                </Button>
                </>
            )}
        >
            <ListPageHeader
                count={lastRowCountRef.current}
                description="아이러빗에 가입한 전체 회원 목록"
            />

            <SearchToolbar
                fields={usersSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={usersColumns}
                isError={tableQueryResult.isError}
                errorMessage="회원 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 회원이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                checkboxSelection
                onRowSelectionModelChange={(model) => setSelectedRows(model.map(String))}
                getRowShowPath={(row) => `/parents/show/${row.id}`}
            />
        </List>
    );
};
